// extracted by mini-css-extract-plugin
module.exports = {"container":"Team_container__1ST8D","member":"Team_member__39wIP","name":"Team_name__2mLMv","description":"Team_description__2wRyd","image":"Team_image__2SgcJ"};